import { attachAuthInterceptor } from '@wheely/web-auth-lib/axios';
import { createAuthClient } from '@wheely/web-auth-lib/core';
import axios from 'axios';

import { userLanguage } from '@/services/userLanguage';

/**
 * Where the auth mediator answers: mounted by vite.mediator.ts in dev and by
 * the deployment in front of server/serve.ts in production. Same origin as the
 * app, so the refresh cookie stays first-party.
 */
export const AUTH_MEDIATOR_BASE = '/auth';

/**
 * Auth client of the new V3 (email-first) stack, mediated topology: the browser
 * talks only to the mediator on this origin. The refresh token lives in an
 * HttpOnly cookie the mediator owns, the access token in memory — nothing auth
 * touches localStorage. All new sign-ins and registrations go through this
 * client; the legacy stack in ./index.ts only serves sessions that existed
 * before the migration and could not be imported yet.
 */
const authClientV3 = createAuthClient({
  gateway: { mediated: { mediatorBase: AUTH_MEDIATOR_BASE } },
  locale: () => userLanguage.getLanguage(),
});

/**
 * App transport for the V3 mode: carries the Bearer token and retries a 401
 * once after a refresh. The legacy mode keeps its own transport in
 * fetch-based-http-methods until V6 support is removed.
 */
const v3Transport = axios.create();

attachAuthInterceptor(v3Transport, authClientV3);

export { authClientV3, v3Transport };
